import { A11yModule } from "@angular/cdk/a11y";
import { BidiModule } from "@angular/cdk/bidi";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UiAccessibilityModule } from "../accessibility/accessibility.module";
import { UiButtonModule } from "../button/button.module";
import { UiI18nModule } from "../i18n/i18n.module";
import { UiIconModule } from "../icon/icon.module";
import { UiTimePickerModule } from "../time-picker/time-picker.module";
import { UiCalendarFooterComponent } from "./components/calendar-footer/calendar-footer.component";
import { UiDateHeaderComponent } from "./components/date-header/date-header.component";
import { UiDateRangePopupComponent } from "./components/date-range-popup/date-range-popup.component";
import { UiDateTableComponent } from "./components/date-table/date-table.component";
import { UiDecadeHeaderComponent } from "./components/decade-header/decade-header.component";
import { UiDecadeTableComponent } from "./components/decade-table/decade-table.component";
import { UiInnerPopupComponent } from "./components/inner-popup/inner-popup.component";
import { UiMonthHeaderComponent } from "./components/month-header/month-header.component";
import { UiMonthTableComponent } from "./components/month-table/month-table.component";
import { UiYearHeaderComponent } from "./components/year-header/year-header.component";
import { UiYearTableComponent } from "./components/year-table/year-table.component";
import { UiDatePickerComponent } from "./date-picker.component";
import { UiMonthPickerComponent } from "./directives/month-picker.directive";
import { UiRangePickerComponent } from "./directives/range-picker.directive";
import { UiWeekPickerComponent } from "./directives/week-picker.directive";
import { UiYearPickerComponent } from "./directives/year-picker.directive";

@NgModule({
  imports: [CommonModule, FormsModule, A11yModule, OverlayModule, BidiModule, UiIconModule, UiTimePickerModule, UiButtonModule, UiI18nModule, UiAccessibilityModule],
  declarations: [
    UiDatePickerComponent,
    UiDateTableComponent,
    UiDateHeaderComponent,
    UiCalendarFooterComponent,
    UiDateRangePopupComponent,
    UiInnerPopupComponent,
    UiRangePickerComponent,
    UiWeekPickerComponent,
    UiDecadeHeaderComponent,
    UiDecadeTableComponent,
    UiMonthPickerComponent,
    UiMonthHeaderComponent,
    UiMonthTableComponent,
    UiYearPickerComponent,
    UiYearHeaderComponent,
    UiYearTableComponent,
  ],
  exports: [UiDatePickerComponent, UiDateRangePopupComponent, UiInnerPopupComponent, UiRangePickerComponent, UiWeekPickerComponent],
})
export class UiDatePickerModule {}
